<template>
  <div class="config column mt-sm-2">
    <div :class="computedClassHeader">Configuração / Mapa</div>
    <div :class="computedClass">
      <div class="col-xs-12 col-sm-6 mt-2">
        <b-card>
          <header slot="header" align="center">
            <h4>
              {{ !localForm ? "Localização do CIR" : "Editar localização" }}
            </h4>
          </header>
          <div>
            <div class="card-text" v-if="!localForm">
              <p><strong>NOME:</strong> {{ positionInfo.NAME }}</p>
              <p>
                <strong>CIDADE:</strong> {{ positionInfo.CITY }} -
                {{ positionInfo.STATE }}
              </p>
              <p>
                <strong>COORDENADAS:</strong> {{ positionInfo.LATITUDE }},
                {{ positionInfo.LONGITUDE }}
              </p>
              <p>
                <strong>ZONA HORÁRIA:</strong> GMT{{
                  positionInfo.UTC > 0
                    ? "+" + positionInfo.UTC
                    : positionInfo.UTC
                }}
              </p>
            </div>
            <div v-else class="no-margins">
              <b-form novalidate @keyup.enter="submitLocation">
                <b-form-text id="nameInputLiveHelp"> Nome * </b-form-text>
                <b-form-input
                  v-model="editLocation.NAME"
                  placeholder="Nome"
                  aria-describedby="nameInputLiveHelp nameInputLiveFeedback"
                  :state="stateLocationName"
                >
                </b-form-input>
                <b-form-invalid-feedback
                  v-if="!stateLocationName"
                  id="nameInputLiveFeedback"
                >
                  Campo inválido.
                </b-form-invalid-feedback>
                <div class="row">
                  <div class="col-xs-8">
                    <b-form-text id="cityInputLiveHelp"> Cidade * </b-form-text>
                    <b-form-input
                      v-model="editLocation.CITY"
                      placeholder="Cidade"
                      aria-describedby="cityInputLiveHelp cityInputLiveFeedback"
                      :state="stateLocationCity"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback
                      v-if="!stateLocationCity"
                      id="cityInputLiveFeedback"
                    >
                      Campo inválido.
                    </b-form-invalid-feedback>
                  </div>
                  <div class="col-xs-4">
                    <b-form-text id="stateInputLiveHelp">
                      Estado *
                    </b-form-text>
                    <b-form-input
                      v-model="editLocation.STATE"
                      placeholder="Estado"
                      aria-describedby="stateInputLiveHelp stateInputLiveFeedback"
                      :state="stateLocationState"
                    >
                    </b-form-input>
                    <b-form-invalid-feedback
                      v-if="!stateLocationState"
                      id="stateInputLiveFeedback"
                    >
                      Campo inválido.
                    </b-form-invalid-feedback>
                  </div>
                </div>
                <b-form-text id="latInputLiveHelp"> Latitude </b-form-text>
                <b-form-input
                  v-model="editLocation.LATITUDE"
                  placeholder="Latitude"
                  aria-describedby="latInputLiveHelp latInputLiveFeedback"
                  :state="stateLAT"
                >
                </b-form-input>
                <b-form-invalid-feedback
                  v-if="!stateLAT"
                  id="latInputLiveFeedback"
                >
                  Ao ser preenchido, o campo só pode conter números, um único
                  ponto decimal e único hífen indicando valor negativo.
                  Latitudes não podem ter valor menor que -90 ou maior que 90
                  graus.
                </b-form-invalid-feedback>
                <p />
                <b-form-text id="lonInputLiveHelp"> Longitude </b-form-text>
                <b-form-input
                  v-model="editLocation.LONGITUDE"
                  placeholder="Longitude"
                  aria-describedby="lonInputLiveHelp lonInputLiveFeedback"
                  :state="stateLON"
                >
                </b-form-input>
                <b-form-invalid-feedback
                  v-if="!stateLON"
                  id="lonInputLiveFeedback"
                >
                  Ao ser preenchido, o campo só pode conter números, um único
                  ponto decimal e único hífen indicando valor negativo.
                  Longitudes não podem ter valor menor que -180 ou maior que 180
                  graus.
                </b-form-invalid-feedback>
                <b-form-text id="utcInputLiveHelp"> Zona horária </b-form-text>
                <b-form-input
                  v-model="editLocation.UTC"
                  placeholder="UTC"
                  type="number"
                  aria-describedby="utcInputLiveHelp utcInputLiveFeedback"
                  :min="-180"
                  :max="180"
                  :state="stateUTC"
                >
                </b-form-input>
              </b-form>
            </div>
          </div>
          <footer slot="footer" class="row around-xs">
            <b-btn
              variant="3v3"
              size="sm"
              v-if="!localForm"
              @click="showLocationForm()"
              ><pencil-icon title=""
            /></b-btn>
            <b-btn
              variant="red"
              size="sm"
              v-if="localForm"
              @click="localForm = false"
              ><close-icon title=""
            /></b-btn>
            <b-btn
              variant="3v3"
              size="sm"
              v-if="localForm"
              @click="submitLocation()"
              ><save-icon title=""
            /></b-btn>
          </footer>
        </b-card>
        <p></p>
      </div>
      <div class="col-xs-12 col-sm-6 mt-2">
        <b-card>
          <header slot="header" align="center">
            <h4>{{ !urlForm ? "URL do Mapa" : "Editar URL" }}</h4>
          </header>
          <div v-if="!urlForm" class="card-text">
            <p>{{ positionInfo.URL_MAP }}</p>
          </div>
          <b-form v-else @keyup.enter="submitURL">
            <b-form-text id="urlInputLiveHelp"> URL * </b-form-text>
            <b-form-input
              v-model="editURL.URL_MAP"
              placeholder="URL"
              aria-describedby="urlInputLiveHelp urlInputLiveFeedback"
              :state="stateURL"
            >
            </b-form-input>
            <b-form-invalid-feedback v-if="!stateURL" id="urlInputLiveFeedback">
              Campo inválido.
            </b-form-invalid-feedback>
          </b-form>
          <footer slot="footer" class="row around-xs">
            <b-btn
              variant="3v3"
              size="sm"
              v-if="!urlForm"
              @click="showMapURLForm()"
              ><pencil-icon title=""
            /></b-btn>
            <b-btn
              variant="red"
              size="sm"
              v-if="urlForm"
              @click="urlForm = false"
              ><close-icon title=""
            /></b-btn>
            <b-btn variant="3v3" size="sm" v-if="urlForm" @click="submitURL()"
              ><save-icon title=""
            /></b-btn>
          </footer>
        </b-card>
        <p></p>
        <b-card>
          <header slot="header" align="center">
            <h4>KML</h4>
          </header>
          <div class="card-text start-xs">
            <strong>Tamanho atual:</strong>
            <span v-if="sizekml.status">{{ sizekml.log }}</span>
          </div>
          <b-btn slot="footer" block @click="openImportKML()" variant="3v3"
            >Importar arquivo...</b-btn
          >
        </b-card>
      </div>
    </div>

    <b-modal
      centered
      ref="importKML"
      no-close-on-backdrop
      hide-header
      @ok="uploadKML"
      ok-title="Fazer upload"
      cancel-title="Cancelar"
    >
      <h5>Importar KML</h5>
      <div class="importBtn">
        <input
          type="file"
          id="kml"
          ref="kml"
          accept=".kml"
          @change="chooseFile"
        />
      </div>
      <div class="start-xs" v-if="file">
        <strong>Arquivo:</strong> {{ file && file.name }}
      </div>
      <div class="start-xs" v-if="file">
        <strong>Tamanho:</strong>
        {{ file && file.size && (file.size / 1000000).toFixed(2) + " MB" }}
      </div>
    </b-modal>
  </div>
</template>

<script>
import { map } from "@/api";
import { checkCoord } from "@/pages/components/helpers";

export default {
  name: "map3v3",
  props: {
    statusCir: [Boolean],
    mobile: Boolean,
  },
  created() {
    map
      .positionInfo()
      .then((ret) => {
        this.positionInfo = ret;
        return map.sizekml();
      })
      .then((ret) => {
        this.sizekml = ret;
      })
      .catch((err) => console.log(err));
  },
  data() {
    return {
      sizekml: {
        status: true,
        log: 0,
      },
      positionInfo: {
        ID: null,
        UPDATE: "2018-01-01T10:00:00.000Z",
        NAME: "",
        CITY: "FORTALEZA",
        STATE: "CE",
        UTC: -3,
        LATITUDE: -3.834086,
        LONGITUDE: -38.476904,
        URL_MAP: "http://sig.3v3.farm",
      },
      localForm: false,
      urlForm: false,
      editURL: {
        URL_MAP: "",
      },
      editLocation: {
        NAME: "",
        CITY: "",
        STATE: "",
        LATITUDE: "",
        LONGITUDE: "",
        UTC: null,
      },
      file: null,
      // positionInfo: this.position(),
    };
  },
  computed: {
    computedClass() {
      if (this.mobile) {
        return "container-cards mobile-header";
      }
      return "container-cards desktop-header mt-2";
    },
    computedClassHeader() {
      if (this.mobile) {
        return "page-title config-title-mobile col-xs-12  mt-0";
      }
      return "page-title config-title col-xs-12  mt-2";
    },
    // validação de formulário personalizada
    stateURL() {
      return this.editURL.URL_MAP != "" && this.editURL.URL_MAP.length < 255;
    },
    stateUTC() {
      return this.editLocation.UTC != null && this.editLocation.UTC != "";
    },
    stateLocationName() {
      return (
        this.editLocation.NAME != "" && this.editLocation.NAME.length < 100
      );
    },
    stateLocationCity() {
      return (
        this.editLocation.CITY != "" && this.editLocation.CITY.length < 100
      );
    },
    stateLocationState() {
      return (
        this.editLocation.STATE != "" && this.editLocation.STATE.length < 100
      );
    },
    stateLAT() {
      return checkCoord(this.editLocation.LATITUDE, 90);
    },
    stateLON() {
      return checkCoord(this.editLocation.LONGITUDE, 180);
    },
  },
  methods: {
    resetForm(type) {
      if (type == "local") {
        this.editLocation.NAME = this.positionInfo.NAME
          ? this.positionInfo.NAME
          : "";
        this.editLocation.CITY = this.positionInfo.CITY
          ? this.positionInfo.CITY
          : "";
        this.editLocation.STATE = this.positionInfo.STATE
          ? this.positionInfo.STATE
          : "";
        this.editLocation.UTC = this.positionInfo.UTC
          ? this.positionInfo.UTC
          : null;
        this.editLocation.LATITUDE = this.positionInfo.LATITUDE
          ? this.positionInfo.LATITUDE
          : "";
        this.editLocation.LONGITUDE = this.positionInfo.LONGITUDE
          ? this.positionInfo.LONGITUDE
          : "";
      } else if (type == "map") {
        this.editURL.URL_MAP = this.positionInfo.URL_MAP
          ? this.positionInfo.URL_MAP
          : "";
      }
    },
    showLocationForm() {
      this.resetForm("local");
      this.localForm = true;
    },
    submitLocation() {
      if (
        this.stateLocationName &&
        this.stateLocationCity &&
        this.stateLocationState &&
        this.stateLAT &&
        this.stateLON &&
        this.stateUTC
      ) {
        let data = {
          ID: this.positionInfo.ID,
          NAME: this.editLocation.NAME,
          CITY: this.editLocation.CITY,
          STATE: this.editLocation.STATE,
          UTC: parseInt(this.editLocation.UTC),
          LATITUDE: parseFloat(this.editLocation.LATITUDE),
          LONGITUDE: parseFloat(this.editLocation.LONGITUDE),
        };
        this.localForm = false;
        map
          .updatePositionInfo(data)
          .then((ret) => {
            alert(ret.log, ret.alert);
            if (ret.status) return map.positionInfo();
          })
          .then((positionInfo) => {
            this.positionInfo = positionInfo;
          })
          .catch((err) => {
            console.log(err);
            alert("Ocorreu um erro. Recarregue a página.");
          });
      }
    },
    showMapURLForm() {
      this.resetForm("map");
      this.urlForm = true;
    },
    submitURL() {
      if (this.stateURL) {
        let data = {
          ID: this.positionInfo.ID,
          URL_MAP: this.editURL.URL_MAP,
        };
        this.urlForm = false;
        map
          .updateMapURL(data)
          .then((ret) => {
            alert(ret.log, ret.alert);
            if (ret.status) return map.positionInfo();
          })
          .then((positionInfo) => {
            this.positionInfo = positionInfo;
          })
          .catch((err) => {
            console.log(err);
            alert("Ocorreu um erro. Recarregue a página.");
          });
      }
    },
    openImportKML() {
      this.$refs.importKML.show();
    },
    chooseFile(evt) {
      let file = this.$refs.kml.files[0];
      if (!window.FileReader) {
        console.log("The file API isn't supported on this browser yet.");
        alert("O naveador não permite a ação.");
        return;
      }
      this.file = file;
    },
    uploadKML(e) {
      if (this.file != null) {
        let formData = new FormData();
        formData.append("file", this.file);
        map
          .kmlImport(formData)
          .then((ret) => {
            console.log(ret);
          })
          .catch((err) => console.log(err));
        this.$router.go();
      } else {
        e.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
.importBtn {
  margin: 10px 0 0;
}
.card-body {
  max-height: 376px;
  overflow: auto;
}
.no-margins {
  line-height: normal;
  margin: -5px auto;
}
.card-text > div > p {
  color: var(--text-gray-primary);
}

.mobile-header {
  margin-top: 40px;
}
.config-title {
  max-height: 1.1em;
  /* padding: 0 0 4px 0; */
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
@media screen and (max-width: 767px) {
  .card-text {
    font-size: 0.88em;
  }
}
</style>
